import { BoxProps, useStyleConfig } from '@chakra-ui/react';
import { mergeWith } from '@chakra-ui/utils';
import PropTypes from 'prop-types';
import React from 'react';

import Spinner from '../LoadingStates/Spinner/Spinner';

export type ButtonSpinnerProps = BoxProps;

interface ButtonSpinnerTypes {
  size?: string;
  sx?: Record<string, unknown>;
}

const defaultProps = {
  size: 'md',
  sx: null
};

export const PropType = {
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
};

const ButtonSpinner = (props: ButtonSpinnerTypes): React.ReactElement => {
  const { size, sx } = props;
  const sxStyles = useStyleConfig('ButtonSpinnerTheme', { size });

  return <Spinner sx={mergeWith(sxStyles, sx)} />;
};

ButtonSpinner.propTypes = PropType;
ButtonSpinner.defaultProps = defaultProps;

export default ButtonSpinner;
